import updateUrlParameter from "@tinqin/tinqin-utils/src/url/updateUrlParameter";

//extract query parameters from a url
//reference
//http://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
export default function extractQueryParam(name, url) {
    let result = "";
    let paramRegex = new RegExp("[?&]" + name + "=([^&#]*)");
    //uses window.location by default
    url = url || window.location.search;

    if (paramRegex.test(url)) {
        result = paramRegex.exec(url)[1];
        //decoding
        result = decodeURIComponent(result.replace(/\+/g, " "));
    }

    return result;
}

//add query parameter to a url
export function addQueryParams(url, parameters) {
    let result = url.slice(0);

    if (Array.isArray(parameters)) {
        for (let i = 0; i < parameters.length; i++) {
            result = updateUrlParameter(result, parameters[i].name, parameters[i].value);
        }
        return result;
    }

    for (let param in parameters) {
        result = updateUrlParameter(result, param, parameters[param]);
    }
    return result;
}
